import React, { Component } from 'react';
import authService from '../api-authorization/AuthorizeService'
import { FormattedMessage } from 'react-intl';
import ExcelUtil from '../utils/ExcelUtil';
import { PaperClipIcon, ArrowCircleDownIcon, SearchIcon } from '@heroicons/react/solid'
import EnclosureImageDialog from './EnclosureImageDialog'
import { AuthorityModules, AuthorityActions } from '../api-authorization/ApiAuthorizationConstants';
import { DeleteButton } from '../controls/DeleteButton';
import { BaseCombobox } from '../controls/BaseCombobox';
import LineParameterConfigurationViewDialog from './LineParameterConfigurationViewDialog'
import { ConfirmAlert } from '../controls/ConfirmAlert'


export class CustomizedMachineModelView extends Component {

    constructor(props) {
        super(props);
        this.state = { selectedProductId: '', products: [], line: "", specsMatrix: "", productCode: "", options: [], loading: true, open: false, isAllowCreate: false, isAllowEdit: false, isAllowDelete: false, selectAll: false, btnBatchDisabled: true, confirmOpen: false };
        this.handleImport = this.handleImport.bind(this);
        this.openEnclosureImageDialog = this.openEnclosureImageDialog.bind(this);
        this.closeEnclosureImageDialog = this.closeEnclosureImageDialog.bind(this);
        this.handleDeleted = this.handleDeleted.bind(this);
        this.handleValueSeleted = this.handleValueSeleted.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.onChange = this.onChange.bind(this);
    }

    async handleValueSeleted(e) {
        var productId = e.target.value;
        this.setState({ selectedProductId: productId, line: "", specsMatrix: "", productCode: "" });
        this.populateListData();

    }
    onChange(e) {
        const target = e.target;
        const value = target.value;
        const name = target.name;
        this.setState({
            [name]: value
        });
    }
    async handleImport(e) {

        this.setState({ options: [], loading: true });
        let setState = this.setState.bind(this);
        let productId = this.state.selectedProductId;
        ExcelUtil.ImportExcel(e).then(async function (list) {
            const token = await authService.getAccessToken();
            let response = await fetch('ProductOption/ImportCustomizedMachineProductOptions', {
                method: 'POST',
                headers: !token ? { 'Content-Type': 'application/json' } : { 'Content-Type': 'application/json', 'Authorization': `${token}` },
                body: JSON.stringify({ productId: productId, importList: list })
            });
            //console.log(productId);
            response = await fetch('ProductOption/GetCustomizedMachineModelOption?productId=' + productId, {
                headers: !token ? {} : { 'Authorization': `${token}` }
            });
            const data = await response.json();
            document.getElementById("fileBrowse").value = "";
            setState({ options: data, loading: false });

        }, function (err) {
            document.getElementById("fileBrowse").value = "";
            console.warn(err);
        });
    }

    openEnclosureImageDialog(e) {
        e.preventDefault();
        this.setState({ open: true });
        const optionCategory = this.props.getSelectedOptionCategroy();
        this.enclosureImageDialog.updateState(optionCategory);
        this.enclosureImageDialog.populateSelectData();
    }
    closeEnclosureImageDialog() {
        this.setState({ open: false });
    }
    async importCustomizedMachineProductOptions(data) {



    }

    async handleSearch() {
        this.populateListData(false);
        this.clearAllSelect();
    }

    async componentDidMount() {
        this.populateListData();
        const create = await authService.isAllow(AuthorityModules.ProductOptions, AuthorityActions.Create);
        const edit = await authService.isAllow(AuthorityModules.ProductOptions, AuthorityActions.Edit);
        const del = await authService.isAllow(AuthorityModules.ProductOptions, AuthorityActions.Delete);
        this.setState({
            isAllowCreate: create, isAllowEdit: edit, isAllowDelete: del
        });
    }
    async populateListData(loadProducts = true) {
        const token = await authService.getAccessToken();

        let products = this.state.products;
        if (loadProducts) {
            const responseProduct = await fetch('Product/GetWsaProducts', {
                headers: !token ? {} : { 'Authorization': `${token}` }
            });
            products = await responseProduct.json();
        }

        var selectedProductId = this.state.selectedProductId;
        if (!selectedProductId && products.length > 0) {
            selectedProductId = products[0].id;
        }
        var line = this.state.line.trim();
        var specsMatrix = this.state.specsMatrix.trim();
        var productCode = this.state.productCode.trim();
        const response = await fetch('ProductOption/GetCustomizedMachineModelOption?productId=' + selectedProductId + "&line=" + line + "&specsMatrix=" + specsMatrix + "&productCode=" + productCode, {
            headers: !token ? {} : { 'Authorization': `${token}` }
        });
        const data = await response.json();
        const options = data.map(item => ({ ...item, checked: false }));
        this.setState({ options: options, loading: false, products: products, selectedProductId: selectedProductId });
        this.clearAllSelect();
    }
    handleDeleted(id) {
        if (id) {
            this.setState({
                options: this.state.options.filter(x => x.id != id)
            });
        }
    }

    handleSelectAll = () => {
        const newChecked = !this.state.selectAll;
        const updatedItems = this.state.options.map(item => ({ ...item, checked: newChecked }));
        this.changeParamConfigStatus(updatedItems);
        this.setState({ options: updatedItems, selectAll: newChecked });
    };

    handleCheckboxChange = (id) => {
        const updatedItems = this.state.options.map(item =>
            item.id === id ? { ...item, checked: !item.checked } : item
        );
        this.changeParamConfigStatus(updatedItems);
        const allChecked = updatedItems.every(item => item.checked);
        this.setState({ options: updatedItems, selectAll: allChecked });
    };

    clearAllSelect = () => {
        const updatedItems = this.state.options.map(item => ({ ...item, checked: false }));
        this.setState({ options: updatedItems, selectAll: false });
    }

    handleOpenParameterConfigDialog = (lineId) => {
        this.parameterConfigurationViewDialog.openDialog();
        if (lineId) {
            this.parameterConfigurationViewDialog.updateLines(this.state.options.filter(x => x.id == lineId));
        } else {
            this.parameterConfigurationViewDialog.updateLines(this.state.options.filter(x => x.checked));
        }

    }

    changeParamConfigStatus = (items) => {
        this.setState({ btnBatchDisabled: items.filter(x => x.checked).length == 0 });
    }

    handleBatchDelete = async () => {
        const selectItems = this.state.options.filter(x => x.checked);
        const dataIds = new Set(selectItems.map(item => item.id));

        const filteredOptions = this.state.options.filter(option => !dataIds.has(option.id));

        this.setState({ options: filteredOptions });
        const token = await authService.getAccessToken();
        await fetch("ProductOption/DeleteBatchCustomizedMachineModelOptions", {
            method: 'POST',
            headers: !token ? { 'Content-Type': 'application/json' } : { 'Content-Type': 'application/json', 'Authorization': `${token}` },
            body: JSON.stringify(selectItems.map(item => item.id))
        });
        this.handleConfirmClose();
    }
    handleConfirmClose = () => {
        this.setState({ confirmOpen: false });
    }
    deletedConfirm = () => {
        this.setState({ confirmOpen: true });
    }

    static renderTable(options, handleDeleted, selectAll, handleSelectAll, handleCheckboxChange, handleOpenParameterConfigDialog) {
        return (<div className="w-full overflow-x-auto">
            <table className='w-full'>
                <thead>
                    <tr className="text-xs font-semibold tracking-wide text-left text-gray-500 uppercase border-b dark:border-gray-700 bg-gray-50 dark:text-gray-400 dark:bg-gray-800">
                        <th className="px-4 py-3"><input type="checkbox" name="selectAll" checked={selectAll} onChange={handleSelectAll} className="w-4 h-4 align-middle mr-1 ml-1" /><span className="inline-block align-middle"><FormattedMessage id="SelectAll" /></span></th>
                        <th className="px-4 py-3"><FormattedMessage id="EnclosureType" /></th>
                        <th className="px-4 py-3"><FormattedMessage id="IsWireless" /></th>
                        <th className="px-4 py-3"><FormattedMessage id="Line" /></th>
                        <th className="px-4 py-3"><FormattedMessage id="SpecsMatrix" /></th>
                        <th className="px-4 py-3"><FormattedMessage id="ProductCode" /></th>
                        <th className="px-4 py-3"><FormattedMessage id="RicCode" /></th>
                        <th className="px-4 py-3"><FormattedMessage id="Actions" /></th>
                    </tr>
                </thead>
                <tbody className="bg-white divide-y dark:divide-gray-700 dark:bg-gray-800">
                    {options.map(a =>
                        <tr key={a.id} className="bg-gra-50 hover:bg-gray-100 text-gray-700 dark:text-gray-400 text-sm">
                            <td className="px-4 py-3"><input type="checkbox" onChange={() => handleCheckboxChange(a.id)} checked={a.checked} name="select" className="w-4 h-4 align-middle mr-1 ml-1" /></td>
                            <td className="px-4 py-3">{a.enclosureType.name}</td>
                            <td className="px-4 py-3">{a.wireless == 1 ? "WL" : "None"}</td>
                            <td className="px-4 py-3">{a.line.name}</td>
                            <td className="px-4 py-3">{a.specsMatrix.name}</td>
                            <td className="px-4 py-3">{a.productCode}</td>
                            <td className="px-4 py-3">{a.ricCode}</td>
                            <td className="px-4 py-3  whitespace-nowrap text-sm font-medium">
                                <a className="cursor-pointer text-indigo-600 hover:text-indigo-900 mr-2" onClick={() => handleOpenParameterConfigDialog(a.id)}>
                                    <FormattedMessage id="ParameterConfiguration" /></a>
                                <DeleteButton module={AuthorityModules.ProductOptions} action={AuthorityActions.Delete} displayname="delete" confirmMsg="DeleteConfirm" url="ProductOption/DeleteCustomizedMachineModelOptions/" id={a.id} onDeleteExecuted={handleDeleted} />
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </div>
        );
    }
    render() {

        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : CustomizedMachineModelView.renderTable(this.state.options, this.handleDeleted, this.state.selectAll, this.handleSelectAll, this.handleCheckboxChange, this.handleOpenParameterConfigDialog);

        return (
            <div className="mt-2">
                <div className="px-3 py-3 flex justify-between gap-4">
                    <div className="flex w-full items-center">
                        <div className="flex w-1/3">
                            <label className="flex-none place-self-center mx-2"><FormattedMessage id="Brand" /></label>
                            <BaseCombobox onChangeCapture={this.handleValueSeleted}>
                                {this.state.products && this.state.products.map(p => <option key={p.id} value={p.id}>{p.name}</option>)}
                            </BaseCombobox>
                        </div>
                        <dt className="text-sm font-medium text-gray-500 mx-2">
                            {this.state.isAllowCreate && <button className="hover:bg-blue-500 hover:text-blue-800 group inline-flex items-center rounded-md bg-blue-600 text-white text-sm font-medium px-4 py-2">
                                <ArrowCircleDownIcon className="-ml-1 mr-2 h-5 w-5 text-white" aria-hidden="true" /><FormattedMessage id="import" />
                                <input id="fileBrowse" type="file" style={{ fontSize: 0 }} className="absolute p-4 -mt-2 -ml-4 opacity-0 w-32 cursor-pointer" accept=".xls,.xlsx" onChange={this.handleImport} />
                            </button>}</dt>
                    </div>
                    <dd className="mt-1 text-sm text-gray-900 w-1/3">
                        <ul className="border border-gray-200 rounded-md divide-y divide-gray-200">
                            <li className="pl-3 pr-4 py-3 flex items-center justify-between text-sm">
                                <div className="w-0 flex-1 flex items-center">
                                    <PaperClipIcon className="flex-shrink-0 h-5 w-5 text-gray-400" aria-hidden="true" />
                                    <span className="ml-2 flex-1 w-0 truncate">CusomerMadeImportTemplate.xlsx</span>
                                </div>
                                <div className="ml-0 flex-shrink-0">
                                    <a href="/Resources/Templates/CusomerMadeImportTemplate.xlsx" className="font-medium text-indigo-600 hover:text-indigo-500">
                                        <FormattedMessage id="DownloadTempalte" />
                                    </a>
                                </div>
                            </li>
                        </ul>
                    </dd>
                </div>
                <div className="px-3 py-1 flex gap-2">
                    <div className="">
                        <label className="flex-none place-self-center mx-2"><FormattedMessage id="Line" /></label>
                        <input type="text" name="line" value={this.state.line} onChange={this.onChange}
                            className="focus:ring-indigo-500 focus:border-indigo-500 shadow-sm sm:text-sm border-gray-300 rounded-md" />
                    </div>
                    <div className="">
                        <label className="flex-none place-self-center mx-2"><FormattedMessage id="SpecsMatrix" /></label>
                        <input type="text" name="specsMatrix" value={this.state.specsMatrix} onChange={this.onChange}
                            className="focus:ring-indigo-500 focus:border-indigo-500 shadow-sm sm:text-sm border-gray-300 rounded-md" />
                    </div>
                    <div className="">
                        <label className="flex-none place-self-center mx-2"><FormattedMessage id="ProductCode" /></label>
                        <input type="text" name="productCode" value={this.state.productCode} onChange={this.onChange}
                            className="focus:ring-indigo-500 focus:border-indigo-500 shadow-sm sm:text-sm border-gray-300 rounded-md" />
                    </div>
                    <div className="flex items-end justify-start pb-1">
                        <span className="hidden sm:block flex-shrink-0">
                            <button className="hover:bg-blue-500 hover:text-blue-800 group flex items-center rounded-md bg-blue-600 text-white text-sm font-medium px-4 py-2 mr-1" onClick={this.handleSearch}>
                                <SearchIcon className="-ml-1 mr-2 h-5 w-5 text-white" aria-hidden="true" /><FormattedMessage id="Search" /></button>
                        </span>

                        <span className="hidden sm:block flex-shrink-0">
                            <button className={this.state.btnBatchDisabled ? "group flex items-center rounded-md bg-gray-400 text-gray-600 text-sm font-medium px-4 py-2 mr-1 cursor-not-allowed" : "hover:bg-blue-500 hover:text-blue-800 group flex items-center rounded-md bg-blue-600 text-white text-sm font-medium px-4 py-2 mr-1"} disabled={this.state.btnBatchDisabled} onClick={() => this.handleOpenParameterConfigDialog(null)}>
                                <FormattedMessage id="ParameterConfiguration" /></button>

                        </span>
                        <span className="hidden sm:block flex-shrink-0">
                            <button className={this.state.btnBatchDisabled ? "group flex items-center rounded-md bg-gray-400 text-gray-600 text-sm font-medium px-4 py-2 mr-1 cursor-not-allowed" : "hover:bg-blue-500 hover:text-blue-800 group flex items-center rounded-md bg-blue-600 text-white text-sm font-medium px-4 py-2 mr-1"} disabled={this.state.btnBatchDisabled} onClick={() => this.deletedConfirm()}>
                                <FormattedMessage id="delete" /></button>

                        </span>
                    </div>
                </div>

                {contents}
                <EnclosureImageDialog onRef={(ref) => { this.enclosureImageDialog = ref }} open={this.state.open} onClose={this.closeEnclosureImageDialog}></EnclosureImageDialog>
                <LineParameterConfigurationViewDialog onRef={(ref) => { this.parameterConfigurationViewDialog = ref }}></LineParameterConfigurationViewDialog>
                <ConfirmAlert onRef={(ref) => { this.confirmRef = ref }} messageId="DeleteBatchConfirm" onCancel={this.handleConfirmClose} onOk={(e) => { this.handleBatchDelete(e) }} open={this.state.confirmOpen} />
            </div>
        );
    }
}
